import { render, staticRenderFns } from "./IgSemiCircularChart.vue?vue&type=template&id=6356db4e"
import script from "./IgSemiCircularChart.vue?vue&type=script&lang=js"
export * from "./IgSemiCircularChart.vue?vue&type=script&lang=js"
import style0 from "./IgSemiCircularChart.vue?vue&type=style&index=0&id=6356db4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports